import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import { SalesSettingsComponent } from './sales-settings.component';


const routes: Routes = [
  {
      path: '',
      component: SalesSettingsComponent,
      canDeactivate:[DeactivateGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalesSettingsRoutingModule { }
